import DevelopmentMainContent from "./DevelopmentContent";

export default DevelopmentMainContent;